import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MapService } from 'src/app/services/map/map.service';

@Component({
  selector: 'app-card-project',
  templateUrl: './card-project.component.html',
  styleUrls: ['./card-project.component.sass'],
})
export class CardProjectComponent implements OnInit, OnDestroy, AfterViewInit {

  chartOption: any;
  isOpen = false;
  @Input() data;
  redirectUrl: string;
  annotationServiceSub: Subscription;
  locationServiceSub: Subscription;
  genericType: any;

  constructor(
    private router: Router,
    private mapService: MapService,
  ) {}

  ngOnInit(): void {
    this.chartOption = {
      responsive: true,
      maintainAspectRatio: false,
      tooltip: {
        triggerOn: 'none',
        show: false,
      },
      xAxis: {
        type: 'category',
        data: ['Q1', 'Q2', 'Q3', 'Q4', 'Q5'],
        axisTick: { alignWithLabel: true },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
      },
      grid: {
        left: '40px',
        bottom: '25px',
        right: '10px',
        top: '15px',
      },
      series: [
        {
          name: 'Safe',
          type: 'bar',
          barWidth: 23,
          stack: 'Total',
          data: [100, 20, 40, 50, 13],
          color: '#B7D0A5',
        },
        {
          name: 'Low',
          type: 'bar',
          stack: 'Total',
          data: [40, 32, 10, 34, 40],
          color: '#EDD773',
        },
        {
          name: 'Medium',
          type: 'bar',
          stack: 'Total',
          data: [20, 82, 91, 34, 90],
          color: '#E4B676',
        },
        {
          name: 'Critical',
          type: 'bar',
          stack: 'Total',
          data: [50, 12, 20, 15, 19],
          color: '#E69390',
        },
      ],
    };
  }

  ngAfterViewInit(): void {}

  onEnter() {}

  toggleCard() {
    this.isOpen = !this.isOpen;
  }

  center() {
    this.mapService.centerTo(this.data.coordinate);
  }

  redirect() {
    this.router.navigate(['/projects', this.data.id, 'details']);
  }

  ngOnDestroy() {
    if (this.annotationServiceSub) this.annotationServiceSub.unsubscribe();
  }
}
